import React, { useEffect } from 'react';
import queryString from 'query-string';
import { Container, Grid, Typography, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { confirmAction } from '../../redux/actions/userAction';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutline from '@material-ui/icons/ErrorOutline';



const ConfirmAccount = (props) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const history = useHistory();

	const confirm = useSelector(state => state.confirm);

	const { token, email } = queryString.parse(location.search);


	useEffect(() => {
		dispatch(confirmAction({ confirmationToken: token }));
	}, [dispatch]);

	if (!token) {
		return <Redirect to='/auth' />;
	}
	return (
		<div>
			<Container>
				<Grid
					container
					justifyContent='center'
					alignItems='center'
					style={{ height: '15vh' }}
					className="mt-5"
				>
					{confirm.loading ? (
						'Loading...'
					) : (
						<>
							<Grid item xs={12} sm={12} md={12}>
								<div className='text-center'>
									{confirm.message ? (
										<>
										<CheckCircleOutlineIcon
										style={{
											fontSize: '5em',
											color: '#198754',
											margin: 'auto',
											display: 'block',
										}}
									/>
										<label className="my-3" >{confirm.message}</label>
										</>
									) : (
											<>
										<h5 className='text-danger'>
											<ErrorOutline
										style={{
											fontSize: '5em',
											color: '#dc3545',
											margin: 'auto',
											display: 'block',
										}}
									/>
										</h5>
											<label className='my-3 '>{confirm.error}</label>
											</>
									)}
								</div>
							</Grid>
							<Grid item xs={12} sm={12} md={12}>
							
								<Typography variant='h6' style={{ textAlign: 'center' }}>
									<Button
										variant='outlined'
										color='primary'
										onClick={() => history.push('/auth', { email })}
									>
										{t('proceed')}
									</Button>
								</Typography>
							</Grid>
						</>
					)}
				</Grid>
			</Container>
		</div>
	);
};

export default ConfirmAccount;
